import type { ListItemProps } from "@/components/ListItem/ListItem";
import MultiSectionDetailsCard from "@/components/MultiSectionDetailsCard";

export const MANAGING_SECTION_LOCATION_CARD_HEADING = "Location";

export function buildManagingSectionLocationItems({
  sectionName,
  location
}: {
  sectionName?: string;
  location?: string;
}): ListItemProps[] {
  return [
    ...(sectionName
      ? [
          {
            iconName: "corporate_fare" as const,
            iconBackground: true,
            overline: "Managing Section",
            headline: sectionName || "Section"
          }
        ]
      : []),
    ...(location
      ? [
          {
            iconName: "location_on" as const,
            iconBackground: true,
            overline: "Location",
            headline: location
          }
        ]
      : [])
  ];
}

type ManagingSectionLocationCardProps = {
  sectionName?: string;
  location?: string;
};

export default function ManagingSectionLocationCard({ sectionName, location }: ManagingSectionLocationCardProps) {
  const items = buildManagingSectionLocationItems({ sectionName, location });
  if (items.length === 0) {
    return null;
  }

  return (
    <MultiSectionDetailsCard
      sections={[
        {
          heading: MANAGING_SECTION_LOCATION_CARD_HEADING,
          options: items
        }
      ]}
    />
  );
}
